module.exports = require("utils-library/dist/time");